<template>
  <div>
    <div class="form-buttons-w">
      <router-link class="btn btn-outline-info" :to="{ name: 'pos-venta' }">
        <i class="fa fa-arrow-left"></i>
        Ir a listado
      </router-link>
      <button
        class="btn btn-sm btn-success"
        data-target="#modalAddProductoPrecio"
        data-toggle="modal"
        href="#"
      >
        <i class="os-icon os-icon-edit-1"></i>
        <span>Modificar Cliente</span>
      </button>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddDetail"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item col-3">
                <a
                  class="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#pills-efectivo"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  >EFECTIVO</a
                >
              </li>
              <li class="nav-item col-3">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#pills-cheque"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  >CHEQUE</a
                >
              </li>
              <li class="nav-item col-3">
                <a
                  class="nav-link"
                  id="pills-contact-tab"
                  data-toggle="pill"
                  href="#pills-tarjeta"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                  >TARJETA DE CREDITO</a
                >
              </li>
              <li class="nav-item col-3">
                <a
                  class="nav-link"
                  id="pills-contact-tab"
                  data-toggle="pill"
                  href="#pills-nota"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                  >NOTA DE CREDITO</a
                >
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-efectivo"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div class="col-12">
                  <div class="col-6 modal-header">
                    <a class="el-tablo centered trend-in-corner">
                      <div class="label">Costo</div>
                      <div>
                        <input
                          class="form-control value"
                          style="text-align: center"
                          placeholder="Q"
                          v-model="currentDetalle.costo"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="pills-cheque"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
              >
                .B..
              </div>
              <div
                class="tab-pane fade"
                id="pills-tarjeta"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
              >
                ..C.
              </div>
              <div
                class="tab-pane fade"
                id="pills-nota"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
              >
                .D..
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" ref="cerrarModal" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Cliente</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="crearPedido">
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <ClientesSelectComponent :current="current" />
                </div>
                <div v-if="current.cliente_nit" class="col-sm-12">
                  <div class="form-group">
                    <label for>Nombre del Cliente</label>
                    <div class="input-group">
                      <input
                        id="cliente_nombre"
                        disabled
                        ref="cliente_nombre"
                        v-model="current.cliente_nit.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="current.cliente_nit" class="col-sm-12">
                  <div class="form-group">
                    <label for>Dirección</label>
                    <div class="input-group">
                      <input
                        id="cliente_direccion"
                        disabled
                        ref="cliente_direccion"
                        v-model="current.cliente_nit.direccion"
                        class="form-control"
                        placeholder="Dirección"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="current.cliente_nit" class="col-sm-12">
                  <div class="form-group">
                    <label for>Correo Electrónico</label>
                    <div class="input-group">
                      <input
                        id="email"
                        disabled
                        v-model="current.cliente_nit.email"
                        ref="email"
                        class="form-control"
                        placeholder="Correo Electrónico"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Agregar</button>
              <button
                class="btn btn-secondary"
                ref="cerrarModal"
                data-dismiss="modal"
                type="button"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import CajaService from "@/services/cxc/CajaService";
import ClienteService from "@/services/catalogos/ClienteService";
import Notifications from "@/notifications/notifications";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import { mapGetters } from "vuex";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";

export default {
  components: {
    UnidadMedidaSelectComponent,
    TiendaSelectComponent,
    ClientesSelectComponent,
  },
  data() {
    return {
      currentDetalle: {},
    };
  },
  props: ["current"],
  watch: {},
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      clientes: "catalogos/clientes",
    }),
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
  },
  mounted() {
    let self = this;
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    self.refreshCajas();
  },
  methods: {
    agregarFormaPago() {
      let self = this;
      $("#modalAddDetail").modal();
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      CajaService.fetch({
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },

    refreshCliente() {
      console.log(self.clientes);
    },

    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    crearPedido(e) {
      let self = this;
      e.preventDefault();
      self.current.caja = self.current.caja.id;
      self.current.tienda = self.current.tienda.codigo;
      self.current.cliente_nombre = self.current.cliente_nit.nombre;
      self.current.cliente_direccion = self.current.cliente_nit.direccion;
      self.current.cliente_nit = self.current.cliente_nit.nit;
      self.current.cliente = self.current.cliente_nit;
      if (!self.current.cliente_nit) {
        Notifications.alert.confirm(
          "Cliente no válido",
          "¿Desea agregar nuevo cliente?",
          "Si",
          function () {
            self.$refs.cerrarModal.click();
            $("#modalAddCliente").modal();
          }
        );
      }
      var _current = Object.assign({}, this.current);
      PedidosServices.save(_current)
        .then((res) => {
          self.current.errors = {};
          Notifications.alert.success("Cliente", "Se ha modificado el cliente");
          self.$emit("refresh", {});
          self.$refs.cerrarModal.click();
          self.cerrandoModal();
        })
        .catch((error) => {
          console.log(error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },
    guardarCliente(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.current.cliente_nit = res.data;
          self.current.errors = {};
          Notifications.alert.confirm(
            "Cliente Agregado exitosamente",
            "¿Desea continuar el pedido?",
            "Si",
            function () {
              self.$refs.cerrarModalCliente.click();
              $("#modalAddProductoPrecio").modal();
            }
          );
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Ups :(", error.response.data.nit[0]);
          }
        });
    },
  },
};
</script>
